
import { useEffect,useState } from "react";
import "./api_content.css"
import ContentView from "./content_view";
import { FaAngleUp } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa6";
import Select from "react-select";
import DropDownButton from "../../../../components/app_wide/drop_down";





const APIContent = ({pageText, setSubText, subText}) =>{
    const [isDropDown, setIsDropDown] = useState(false);

    const [overviewStates, setOverviewStates] = useState([true]);
    const [financialsStates, setFinancialsStates] = useState([true,false,false]);
    const [supplementStates, setSupplementStates] = useState([true,false,false,false,false]);
    const [reitsStates, setReitsStates] = useState([true,false,false,false,false]);
    const [indexStates, setIndexStates] = useState([true,false,false]);

    const value_map = {
        'overview' : overviewStates,
        'financials':financialsStates,
        'supplements':supplementStates,
        'reits':reitsStates,
        'indexes':indexStates,
    }

    useEffect(()=>{
        console.log("Current Page Text: ", pageText);
    }, [pageText])

    const options_overview = [
        { value: "setup", label: "setup" },
    ];

    const options_financials = [
        { value: "get_balance_sheet", label: "get_balance_sheet" },
        { value: "get_income_statement", label: "get_income_statement" },
        { value: "get_cashflow_statement", label: "get_cashflow_statement" },
    ];

    const options_supplement = [
        { value: "get_cpi", label: "get_cpi" },
        { value: "get_gdp", label: "get_gdp" },
        { value: "get_real_gdp", label: "get_real_gdp" },
        { value: "get_unemployment", label: "get_unemployment" },
        { value: "get_m2_supply", label: "get_m2_supply" },
        { value: "get_michigan_consumer_sentiment", label: "get_michigan_consumer_sentiment" },
    ];

    const options_reits = [
        { value: "ten_year_treasury", label: "ten_year_treasury" },
        { value: "two_year_treasury", label: "two_year_treasury" },
        { value: "thirty_year_mortgage", label: "thirty_year_mortgage" },
        { value: "single_family_houses_created", label: "single_family_houses_created" },
        { value: "single_family_houses_sold", label: "single_family_houses_sold" },
    ];

    const options_indexs = [
        { value: "sp_500_index", label: "sp_500_index" },
        { value: "dow_average_index", label: "dow_average_index" },
        { value: "nasdq_composite_index", label: "nasdq_composite_index" },
    ];

    const options_etfs = [
        { value: "get_all_etf", label: "get_all_etf" },
    ];


    const optionMap = {
        overview: options_overview,
        financials: options_financials,
        supplements: options_supplement,
        reits: options_reits,
        indexes: options_indexs,
        /*etfs: options_etfs,*/
      };
    const subOptionMap = {
        setup:0,
        get_balance_sheet:1,
        get_income_statement:2,
        get_cashflow_statement:3,
        get_cpi:4,
        get_gdp:5,
        get_real_gdp:6,
        get_unemployment:7,
        get_m2_supply:8,
        get_michigan_consumer_sentiment:9,
        ten_year_treasury:10,
        two_year_treasury:11,
        thirty_year_mortgage: 12,
        single_family_houses_created: 13,
        single_family_houses_sold: 14,
        sp_500_index:15,
        dow_average_index:16,
        nasdq_composite_index:17,
    }
      
      

    const apiContentRoutes = 
        {
            overview: ["Setup"],
            financials: ["Balance Sheet","Income Statement", "CashFlow Statement"],
            supplements: ["CPI","GDP","Real GDP", "Unemployement", "M2 Supply", "Consumer Sentiment", "10 Year Treasury", "2 Year Treasury", "Non-Farm Payroll", "Capacity Util"],
            reits: ["New Private Owned Housing", "New Housing Sold", "30 Year Mortgage Rate"],
            indexes: ["S&P 500 Index", "DOW Jones Industrial Average Index", "NASDQ Composite Index"],
            etfs: ["tracked", "EEM", "IYC"],
        };

    const sections = [
        { 
        id: "section-1", 
        title: "Setup", 
        content: "Instructions on how to get started, authenticate your account, and make your first API request.", 
        endpoint: null },
      
        { id: "section-2", 
        title: "Balance Sheet", 
        source: "The source of this data is a combination of company website and SEC FiIlings.",
        overview: "Retrieve a company’s balance sheet over a specified time frame, including assets, liabilities, and equity.", 
        endpoint: "get_balance_sheets", 
        type: "POST",
        full_endpoint: "v1/financials/get_balance_sheets",
        api_response: [
            {
              "date": "2024-01-01",
              "cash_and_cash_equivalent": 78779000000,
              "short_term_marketable_securities": 22423000000,
              "accounts_receivable": 55451000000,
              "inventory": 34214000000,
              "other_current_assets_and_deferred_income": null,
              "total_current_assets": 190867000000,
              "property_plant_and_equipment": 252665000000,
              "goodwill": null,
              "other_assets_and_intangible_assets": null,
              "total_assets": 624894000000,
              "accounts_payable": 94363000000,
              "accrued_expenses": 66965000000,
              "other_non_current_liabilities_and_deffered_income": null,
              "total_current_liabilities": 179431000000,
              "total_liabilities": 52623000000,
              "total_shareholder_equity": 285970000000,
              "total_shareholder_equity_and_liabilities": 624894000000,
              "stock_symbol": "AMZN",
              "type": "10k"
            },
            {
              "date": "2023-01-01",
              "cash_and_cash_equivalent": 73387000000,
              "short_term_marketable_securities": 13393000000,
              "accounts_receivable": 52253000000,
              "inventory": 33318000000,
              "other_current_assets_and_deferred_income": null,
              "total_current_assets": 172351000000,
              "property_plant_and_equipment": 204177000000,
              "goodwill": null,
              "other_assets_and_intangible_assets": 56024000000,
              "total_assets": 527854000000,
              "accounts_payable": 84981000000,
              "accrued_expenses": 64709000000,
              "other_non_current_liabilities_and_deffered_income": null,
              "total_current_liabilities": 164917000000,
              "total_liabilities": null,
              "total_shareholder_equity": 201875000000,
              "total_shareholder_equity_and_liabilities": 527854000000,
              "stock_symbol": "AMZN",
              "type": "10k"
            }
          ],
        request_fields: [
            {
            title:"stock_symbol", 
            fields:'(string, required)',
            explanation: "The ticker symbol of the stock",
            example: "Example: AAPL, MSFT, TSLA"
            },
            {
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
      
        { 
        id: "section-3", 
        title: "Income Statement", 
        source: "The source of this data is a combination of company website and SEC FiIlings.",
        overview: "Access the income statement of a company, showing revenue, expenses, and net income for a given period.", 
        endpoint: "get_income_sheets", 
        type: "POST",
        full_endpoint: "v1/financials/get_income_sheets",
        api_response: [
            {
              "date": "2024-01-01",
              "operating_expense": 569366000000,
              "operating_income": 68593000000,
              "other_income_slash_expense": -2250000000,
              "eps_basic": 5.66,
              "eps_diluted": 5.53,
              "cost_of_sales": 326288000000,
              "net_sales": 637959000000,
              "gross_margin": null,
              "net_income": 59248000000,
              "comprehensive_income": 62254000000,
              "comprehensive_shareholder_income": null,
              "stock_symbol": "AMZN",
              "type": "10k"
            },
            {
              "date": "2023-01-01",
              "operating_expense": 537933000000,
              "operating_income": 36852000000,
              "other_income_slash_expense": 938000000,
              "eps_basic": 2.95,
              "eps_diluted": 2.9,
              "cost_of_sales": 304739000000,
              "net_sales": 574785000000,
              "gross_margin": null,
              "net_income": 30425000000,
              "comprehensive_income": 31872000000,
              "comprehensive_shareholder_income": null,
              "stock_symbol": "AMZN",
              "type": "10k"
            }
          ],
        request_fields: [{
            title:"stock_symbol", 
            fields:'(string, required)',
            explanation: "The ticker symbol of the stock",
            example: "Example: AAPL, MSFT, TSLA"
            },      
        
        {
            title:"authorization", 
            fields:'(string, required)',
            explanation: "Your API access token.",
            example: "Example: API_TOKEN_123"
        }] },
      
        { 
        id: "section-4",
        title: "CashFlow Statement",
        source: "The source of this data is a combination of company website and SEC FiIlings.",
        overview: "Pull a company’s cash flow statement to analyze operating, investing, and financing cash movements.", 
        endpoint: "get_cashflow_sheets", 
        type: "POST",
        full_endpoint: "v1/financials/get_cashflow_sheets",
        api_response: [
            {
              "date": "2024-01-01",
              "net_income": 59248000000,
              "change_in_accounts_payable": 2972000000,
              "change_in_inventory": 1884000000,
              "total_non_cash_item": null,
              "change_in_deferred_income_tax": -4648000000,
              "change_in_accounts_receivable": -3249000000,
              "depreciation": 52795000000,
              "net_revenue_from_operating_activities": 84946000000,
              "net_revenue_acqusition_slash_divestitures": -7082000000,
              "net_purchase_slash_sale_of_property_plant_and_equipment": -82999000000,
              "other_investing_activities": null,
              "net_revenue_from_investing_activities": -94342000000,
              "repurchase_of_common_stock": 0,
              "other_financial_activities": null,
              "dividends_payed": null,
              "net_revenue_from_financial_activities": -11812000000,
              "net_change_in_cash_and_equivalent": 82312000000,
              "stock_symbol": "AMZN",
              "type": "10k"
            },
            {
              "date": "2023-01-01",
              "net_income": 30425000000,
              "change_in_accounts_payable": 5473000000,
              "change_in_inventory": 1449000000,
              "total_non_cash_item": null,
              "change_in_deferred_income_tax": -5876000000,
              "change_in_accounts_receivable": -8348000000,
              "depreciation": 48663000000,
              "net_revenue_from_operating_activities": 84946000000,
              "net_revenue_acqusition_slash_divestitures": -5839000000,
              "net_purchase_slash_sale_of_property_plant_and_equipment": -52729000000,
              "other_investing_activities": null,
              "net_revenue_from_investing_activities": -49833000000,
              "repurchase_of_common_stock": null,
              "other_financial_activities": null,
              "dividends_payed": null,
              "net_revenue_from_financial_activities": -15879000000,
              "net_change_in_cash_and_equivalent": 19637000000,
              "stock_symbol": "AMZN",
              "type": "10k"
            }
          ],
        request_fields: [{
            title:"stock_symbol", 
            fields:'(string, required)',
            explanation: "The ticker symbol of the stock",
            example: "Example: AAPL, MSFT, TSLA"
            },      {
            title:"authorization", 
            fields:'(string, required)',
            explanation: "Your API access token.",
            example: "Example: API_TOKEN_123"
        }] },
      
        { 
        id: "section-5", 
        title: "CPI", 
        source: "The source of this data is St Louis Fed website",
        overview: "Fetch Consumer Price Index (CPI) data, measuring inflation over time.", 
        endpoint: "get_cpi",
        type: "GET",
        full_endpoint: "v1/supplements/cpis",
        api_response: [
            {
                "date": "1993-01-01",
                "index_value": 84.3
            },
            {
                "date": "1993-02-01",
                "index_value": 84.3
            },
            {
                "date": "1993-03-01",
                "index_value": 84.4
            },
            {
                "date": "1993-04-01",
                "index_value": 84.3
            },
            {
                "date": "1993-05-01",
                "index_value": 84.5
            },
            {
                "date": "1993-06-01",
                "index_value": 84.5
            },
            {
                "date": "1993-07-01",
                "index_value": 84.8
            },
            {
                "date": "1993-08-01",
                "index_value": 85.6
            },
            {
                "date": "1993-09-01",
                "index_value": 87
            }
          ], 
        request_fields: [     {
            title:"authorization", 
            fields:'(string, required)',
            explanation: "Your API access token.",
            example: "Example: API_TOKEN_123"
        }] },
      
        { 
        id: "section-6", 
        title: "GDP", 
        source: "The source of this data is St Louis Fed website",
        overview: "Retrieve Gross Domestic Product (GDP) data to track overall economic output.", 
        endpoint: "get_gdp", 
        type: "GET",
        full_endpoint: "v1/supplements/gdp",
        api_response: [
                {
                    "date": "1947-01-01",
                    "billion_of_dollars": 243.16
                },
                {
                    "date": "1947-04-01",
                    "billion_of_dollars": 245.97
                },
                {
                    "date": "1947-07-01",
                    "billion_of_dollars": 249.59
                },
                {
                    "date": "1947-10-01",
                    "billion_of_dollars": 259.75
                },
                {
                    "date": "1948-01-01",
                    "billion_of_dollars": 265.74
                },
                {
                    "date": "1948-04-01",
                    "billion_of_dollars": 272.57
                },
                {
                    "date": "1948-07-01",
                    "billion_of_dollars": 279.2
                }
          ],
        request_fields: [{
            title:"authorization", 
            fields:'(string, required)',
            explanation: "Your API access token.",
            example: "Example: API_TOKEN_123"
        }] },
      
        { 
        id: "section-7", 
        title: "Real GDP",
        source: "The source of this data is St Louis Fed website",
        overview: "Get inflation-adjusted GDP figures (Real GDP) for accurate economic growth tracking.", 
        endpoint: "get_real_gdp", 
        type: "GET",
        full_endpoint: "v1/supplements/real_gdp",
        api_response: [
            {
                "date": "1947-01-01",
                "billion_of_dollars": 2182.68
              },
              {
                "date": "1947-04-01",
                "billion_of_dollars": 2176.89
              },
              {
                "date": "1947-07-01",
                "billion_of_dollars": 2172.43
              },
              {
                "date": "1947-10-01",
                "billion_of_dollars": 2206.45
              },
              {
                "date": "1948-01-01",
                "billion_of_dollars": 2239.68
              },
              {
                "date": "1948-04-01",
                "billion_of_dollars": 2276.69
              },
              {
                "date": "1948-07-01",
                "billion_of_dollars": 2289.77
              },
              {
                "date": "1948-10-01",
                "billion_of_dollars": 2292.36
              },
       
          ],
        request_fields: [     {
            title:"authorization", 
            fields:'(string, required)',
            explanation: "Your API access token.",
            example: "Example: API_TOKEN_123"
        }] },
      
        {
        id: "section-8", 
        title: "Unemployment", 
        source: "The source of this data is St Louis Fed website",
        overview: "Pull unemployment rate data to measure labor market conditions.", 
        endpoint: "get_unemployment",
        type: "GET",
        full_endpoint: "v1/supplements/unemployment",
        api_response: [
            {
                "date": "1948-01-01",
                "percent": 3.4
              },
              {
                "date": "1948-02-01",
                "percent": 3.8
              },
              {
                "date": "1948-03-01",
                "percent": 4
              },
              {
                "date": "1948-04-01",
                "percent": 3.9
              },
              {
                "date": "1948-05-01",
                "percent": 3.5
              },
              {
                "date": "1948-06-01",
                "percent": 3.6
              }
          ], 
        request_fields: [     {
            title:"authorization", 
            fields:'(string, required)',
            explanation: "Your API access token.",
            example: "Example: API_TOKEN_123"
        }] },
      
        { 
        id: "section-9", 
        title: "M2 Supply", 
        source: "The source of this data is St Louis Fed website",
        overview: "Access M2 money supply data to analyze liquidity in the economy.",
        endpoint: "get_m2_supply", 
        type: "GET",
        full_endpoint: "v1/supplements/m2_supply",
        api_response: [
            {
                "date": "1980-11-03",
                "billion_of_dollars": 1595.2
              },
              {
                "date": "1980-11-10",
                "billion_of_dollars": 1601.2
              },
              {
                "date": "1980-11-17",
                "billion_of_dollars": 1602.9
              },
              {
                "date": "1980-11-24",
                "billion_of_dollars": 1594.8
              },
              {
                "date": "1980-12-01",
                "billion_of_dollars": 1599.8
              },
              {
                "date": "1980-12-08",
                "billion_of_dollars": 1605.3
              },
              {
                "date": "1980-12-15",
                "billion_of_dollars": 1606.3
              },
              {
                "date": "1980-12-22",
                "billion_of_dollars": 1602.5
              }
            
          ],
        request_fields: [{
            title:"authorization", 
            fields:'(string, required)',
            explanation: "Your API access token.",
            example: "Example: API_TOKEN_123"
        }] 
        },
        { 
            id: "section-9", 
            title: "Michigan Consumer Sentiment", 
            source: "The source of this data is St Louis Fed website",
            overview: "Measure consumer confidence and expectations about the economy, providing insight into future consumer spending and economic trends.",
            endpoint: "michigan_consumer_sentiment", 
            type: "GET",
            full_endpoint: "v1/supplements/michigan_consumer_sentiment",
            api_response: [
                {
                    "date": "1952-11-01",
                    "index_value": 86.2
                  },
                  {
                    "date": "1952-12-01",
                    "index_value": null
                  },
                  {
                    "date": "1953-01-01",
                    "index_value": null
                  },
                  {
                    "date": "1953-02-01",
                    "index_value": 90.7
                  },
                  {
                    "date": "1953-03-01",
                    "index_value": null
                  },
                  {
                    "date": "1953-04-01",
                    "index_value": null
                  },
                  {
                    "date": "1953-05-01",
                    "index_value": null
                  },
                  {
                    "date": "1953-06-01",
                    "index_value": null
                  }
              ],
            request_fields: [{
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
        { 
            id: "section-9", 
            title: "Ten Year Treasury", 
            source: "The source of this data is St Louis Fed website",
            overview: "Track the 10-year U.S. Treasury yield, a key benchmark for interest rates that influences mortgages, loans, and long-term investment decisions.",
            endpoint: "ten_year_treasury",
            type: "GET",
            full_endpoint: "v1/reits/ten_year_treasury",
            api_response: [
            {
                "date": "2024-11-01",
                "percent": 4.36
              },
              {
                "date": "2024-12-01",
                "percent": 4.39
              },
              {
                "date": "2025-01-01",
                "percent": 4.63
              },
              {
                "date": "2025-02-01",
                "percent": 4.45
              },
              {
                "date": "2025-03-01",
                "percent": 4.28
              },
              {
                "date": "2025-04-01",
                "percent": 4.28
              },
              {
                "date": "2025-05-01",
                "percent": 4.42
              },
              {
                "date": "2025-06-01",
                "percent": 4.38
              },
              {
                "date": "2025-07-01",
                "percent": 4.39
              }
              ], 
            request_fields: [{
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
        { 
            id: "section-9", 
            title: "Two Year Treasury", 
            source: "The source of this data is St Louis Fed website",
            overview: "Monitor the 2-year U.S. Treasury yield, often used as an indicator of short-term interest rate expectations and monetary policy outlook.",
            endpoint: "two_year_treasury", 
            type: "GET",
            full_endpoint: "v1/reits/two_year_treasury",
            api_response: [
                {
                    "date": "2024-11-01",
                    "percent": 4.26
                  },
                  {
                    "date": "2024-12-01",
                    "percent": 4.23
                  },
                  {
                    "date": "2025-01-01",
                    "percent": 4.27
                  },
                  {
                    "date": "2025-02-01",
                    "percent": 4.21
                  },
                  {
                    "date": "2025-03-01",
                    "percent": 3.97
                  },
                  {
                    "date": "2025-04-01",
                    "percent": 3.78
                  },
                  {
                    "date": "2025-05-01",
                    "percent": 3.92
                  },
                  {
                    "date": "2025-06-01",
                    "percent": 3.89
                  },
                  {
                    "date": "2025-07-01",
                    "percent": 3.88
                  }
              ],
            request_fields: [{
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
        { 
            id: "section-9", 
            title: "Thirty Year Treasury", 
            source: "The source of this data is St Louis Fed website",
            overview: "Access long-term mortgage rate data, reflecting borrowing costs for homebuyers and trends in the housing market.",
            endpoint: "thirty_year_mortgage", 
            type: "GET",
            full_endpoint: "v1/reits/thirty_year_mortgage",
            api_response: [
                {
                    "date": "2025-08-07",
                    "percent": 6.63
                  },
                  {
                    "date": "2025-08-14",
                    "percent": 6.58
                  },
                  {
                    "date": "2025-08-21",
                    "percent": 6.58
                  },
                  {
                    "date": "2025-08-28",
                    "percent": 6.56
                  },
                  {
                    "date": "2025-09-04",
                    "percent": 6.5
                  },
                  {
                    "date": "2025-09-11",
                    "percent": 6.35
                  },
                  {
                    "date": "2025-09-18",
                    "percent": 6.26
                  },
                  {
                    "date": "2025-09-25",
                    "percent": 6.3
                  },
                  {
                    "date": "2025-10-02",
                    "percent": 6.34
                  },
                  {
                    "date": "2025-10-09",
                    "percent": 6.3
                  }
                
              ],
            request_fields: [{
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
        { 
            id: "section-9", 
            title: "New Single Family Houses Created", 
            source: "The source of this data is St Louis Fed website",
            overview: "Analyze the number of new single-family housing units started, providing insight into construction activity and housing supply.",
            endpoint: "new_single_family_houses_created",
            type: "GET",
            full_endpoint: "v1/reits/new_single_family_houses_created",
            api_response: [
                {
                    "date": "1959-01-01",
                    "thousands_of_persons": 1657
                  },
                  {
                    "date": "1959-02-01",
                    "thousands_of_persons": 1667
                  },
                  {
                    "date": "1959-03-01",
                    "thousands_of_persons": 1620
                  },
                  {
                    "date": "1959-04-01",
                    "thousands_of_persons": 1590
                  },
                  {
                    "date": "1959-05-01",
                    "thousands_of_persons": 1498
                  },
                  {
                    "date": "1959-06-01",
                    "thousands_of_persons": 1503
                  },
              ], 
            request_fields: [{
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
        { 
            id: "section-9", 
            title: "New Single Family Houses Sold", 
            source: "The source of this data is St Louis Fed website",
            overview: "Track sales of newly built single-family homes, offering a view into housing demand and overall economic health.",
            endpoint: "new_single_family_houses_sold", 
            type: "GET",
            full_endpoint: "v1/reits/new_single_family_houses_sold",
            api_response: [
                {
                    "date": "1963-01-01",
                    "thousands_of_persons": 560
                  },
                  {
                    "date": "1964-01-01",
                    "thousands_of_persons": 565
                  },
                  {
                    "date": "1965-01-01",
                    "thousands_of_persons": 575
                  },
                  {
                    "date": "1966-01-01",
                    "thousands_of_persons": 461
                  },
                  {
                    "date": "1967-01-01",
                    "thousands_of_persons": 487
                  },
                  {
                    "date": "1968-01-01",
                    "thousands_of_persons": 490
                  }
              ],
            request_fields: [{
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
        { 
            id: "section-9", 
            title: "S&P 500 Index", 
            source: "The source of this data is St Louis Fed website",
            overview: "Follow the performance of 500 leading U.S. companies, serving as a broad indicator of the overall stock market and economic conditions.",
            endpoint: "s&p_500_index", 
            type: "GET",
            full_endpoint: "v1/indexs/s&p_500_index",
            api_response: [
                {
                    "date": "2020-08-27",
                    "index": 3484.55
                  },
                  {
                    "date": "2020-08-28",
                    "index": 3508.01
                  },
                  {
                    "date": "2020-08-31",
                    "index": 3500.31
                  },
                  {
                    "date": "2020-09-01",
                    "index": 3526.65
                  },
                  {
                    "date": "2020-09-02",
                    "index": 3580.84
                  },
                  {
                    "date": "2020-09-03",
                    "index": 3455.06
                  },
              ],
            request_fields: [{
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
        { 
            id: "section-9", 
            title: "Dow Jones Index", 
            source: "The source of this data is St Louis Fed website",
            overview: "Monitor the Dow Jones Industrial Average, representing 30 major U.S. companies and reflecting large-cap market performance.",
            endpoint: "dow_jones_index", 
            type: "GET",
            full_endpoint: "v1/indexs/dow_jones_index",
            api_response: [
                {
                    "date": "2021-01-21",
                    "index": 31176.01
                  },
                  {
                    "date": "2021-01-22",
                    "index": 30996.98
                  },
                  {
                    "date": "2021-01-25",
                    "index": 30960
                  },
                  {
                    "date": "2021-01-26",
                    "index": 30937.04
                  },
                  {
                    "date": "2021-01-27",
                    "index": 30303.17
                  },
                  {
                    "date": "2021-01-28",
                    "index": 30603.36
                  },
              ],
            request_fields: [{
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
        { 
            id: "section-9", 
            title: "NASDAQ Composite Index", 
            source: "The source of this data is St Louis Fed website",
            overview: "Track the performance of technology-heavy and growth-oriented companies listed on the NASDAQ exchange, often used to gauge innovation and growth sectors.",
            endpoint: "nasdaq_composite_index", 
            type: "GET",
            full_endpoint: "v1/indexs/nasdaq_composite_index",
            api_response: [
                {
                    "date": "2020-12-28",
                    "index": 12899.42
                  },
                  {
                    "date": "2020-12-29",
                    "index": 12850.22
                  },
                  {
                    "date": "2020-12-30",
                    "index": 12870
                  },
                  {
                    "date": "2020-12-31",
                    "index": 12888.28
                  },
                  {
                    "date": "2021-01-01",
                    "index": null
                  }
              ],
            request_fields: [{
                title:"authorization", 
                fields:'(string, required)',
                explanation: "Your API access token.",
                example: "Example: API_TOKEN_123"
            }] 
        },
      
        /*{ id: "section-10", title: "Consumer Sentiment", content: "Retrieve University of Michigan Consumer Sentiment Index data to gauge household confidence.", endpoint: "michigan_consumer_sentiment", column: ["authorization"] },
      
        { id: "section-11", title: "10 Year Treasury", content: "Fetch 10-Year Treasury yield data for long-term interest rate trends.", endpoint: "ten_year_treasury", column: ["authorization"] },
      
        { id: "section-12", title: "2 Year Treasury", content: "Retrieve 2-Year Treasury yield data for short-term bond market analysis.", endpoint: "two_year_treasury", column: ["authorization"] },
      
        { id: "section-13", title: "Non-Farm Payroll", content: "Access monthly U.S. employment data excluding farm workers, a key labor market indicator.", endpoint: "non_farm_payroll", column: ["authorization"] },
      
        { id: "section-14", title: "Capacity Util", content: "Pull Capacity Utilization data to measure industrial sector efficiency and output levels.", endpoint: "cap_util", column: ["authorization"] },
      
        { id: "section-15", title: "New Private Owned Housing", content: "Retrieve data on new privately owned single-family houses created.", endpoint: "new_single_family_houses_created", column: ["authorization"] },
      
        { id: "section-16", title: "New Housing Sold", content: "Fetch statistics on sales of new single-family homes.", endpoint: "new_single_family_houses_sold", column: ["authorization"] },
      
        { id: "section-17", title: "30 Year Mortgage Rate", content: "Retrieve historical 30-Year fixed mortgage rates, a key housing market indicator.", endpoint: "thirty_year_mortgage", column: ["authorization"] },
      
        { id: "section-18", title: "S&P 500 Index", content: "Access S&P 500 Index values for broad U.S. stock market performance tracking.", endpoint: "s&p_500_index", column: ["authorization"] },
      
        { id: "section-19", title: "DOW Jones Industrial Average Index", content: "Retrieve Dow Jones Industrial Average data, representing 30 major U.S. companies.", endpoint: "dow_jones_index", column: ["authorization"] },
      
        { id: "section-20", title: "NASDQ Composite Index", content: "Retrieve NASDQ Composite Index, representing over 3000 common equities listed on the NASDAQ stock Market.", endpoint: "nasdaq_composite_index", column: ["authorization"] },*/
      
    ];

      const getOption = (page)=>{
        switch(page.toLowerCase()){
            case "overview":
                return options_overview
            case "financials":
                return options_financials
            case  "supplements":
                return options_supplement
            case "reits":
                return options_reits
            case "indexes":
                return options_indexs
            case "etfs":
                return options_etfs
            default:
                return options_overview
        }
      }

      const dropDownChange = (end) =>{
        setSubText(end);
        setIsDropDown(false);
      }

      const testAPIResponse = 
        [
            {
              "userId": 1,
              "id": 1,
              "title": "sunt aut facere repellat provident occaecati excepturi optio reprehenderit",
              "body": "quia et suscipit\nsuscipit recusandae consequuntur expedita et cum\nreprehenderit molestiae ut ut quas totam\nnostrum rerum est autem sunt rem eveniet architecto"
            },
            {
              "userId": 1,
              "id": 2,
              "title": "qui est esse",
              "body": "est rerum tempore vitae\nsequi sint nihil reprehenderit dolor beatae ea dolores neque\nfugiat blanditiis voluptate porro vel nihil molestiae ut reiciendis\nqui aperiam non debitis possimus qui neque nisi nulla"
            },
            {
              "userId": 1,
              "id": 3,
              "title": "ea molestias quasi exercitationem repellat qui ipsa sit aut",
              "body": "et iusto sed quo iure\nvoluptatem occaecati omnis eligendi aut ad\nvoluptatem doloribus vel accusantium quis pariatur\nmolestiae porro eius odio et labore et velit aut"
            },
            {
              "userId": 1,
              "id": 4,
              "title": "eum et est occaecati",
              "body": "ullam et saepe reiciendis voluptatem adipisci\nsit amet autem assumenda provident rerum culpa\nquis hic commodi nesciunt rem tenetur doloremque ipsam iure\nquis sunt voluptatem rerum illo velit"
            }
        ]

      useEffect(()=>{
        console.log("sub header: ",subOptionMap[subText]);
      },[subText]);

    return(
        <div className="api_content_container">
            <div className="api_page_drop_down_container">
                
                {<div className="api_page_drop_down_selection">
                    <DropDownButton isdropdown={isDropDown} setisdropdown={setIsDropDown} title={subText} sections={getOption(pageText)}
                    />
                    
                </div>}
                {
                    isDropDown && <div className="api_drop_down_pop_modal">
                        {
                            getOption(pageText).map((endpoint,index) =>(
                                <div key={index}>
                                    <button 
                                    className={index < getOption(pageText).length-1?"api_drop_down_pop_modal_button api_drop_down_pop_modal_button_seperator":"api_drop_down_pop_modal_button" } 
                                    onClick={() => dropDownChange(endpoint.value)} style={{width:'100%', textAlign:'left', paddingLeft:'10px'}}>
                                        {endpoint.label}</button>
                                </div>
                            ))
                        }
                    </div>
                }
            </div>
        
            {<ContentView page={pageText} subTitle={subText} section_info={sections} sectionMap={subOptionMap} />}
        </div>
    );
}

export default APIContent;